<template>
	<Slides :slides="slides" class="top-content" />
</template>

<script>
import { $src } from '@/lib/utils'

import Slides from './Slides.vue'

export default {
	name: 'SlidesResponsibility',
	components: {
		Slides,
	},
	data: () => ({
		slides: [
				{
					body: `<img src="${$src('/assets/slides/responsibility/arise.png')}" alt="Arise" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Arise</h4><span>Asian Representation in Innovation, Success,
and Excellence</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/bold.png')}" alt="Bold" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Bold</h4><span>Black Organizers &amp; Leaders of DTCC</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/ignite.png')}" alt="Ignite" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Ignite</h4><span>Supporting professional development for all career stages</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/mvp.png')}" alt="MVP" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">MVP</h4><span>Military Veterans &amp; Partners</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/pride.png')}" alt="Pride" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Pride</h4><span>LGBTQIA</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/unidos.png')}" alt="Unidos" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Unidos</h4><span>Hispanic/Latinx</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/wethrive.png')}" alt="Wethrive" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">Wethrive</h4><span>Supporting those with a spectrum of abilities and caregivers</span>`
				},
				{
					body: `<img src="${$src('/assets/slides/responsibility/wins.png')}" alt="WINS" class="ml-auto mr-auto" /><h4 class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow">WINS</h4><span>Women’s Initiative for Networking &amp; Success</span>`
				},

			]
	})
}
</script>

<style scoped lang="scss">
@include modules.media-query('phone') {

	:deep(img) {
		object-fit: contain;
		max-height: 70px;
		flex: 1;
	}
	:deep(.title) {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}
	:deep(.mb-1) {
		margin-bottom: 0 !important;
	}
	:deep(span) {
		font-size: 10px !important;
		// flex: 1;
	}
}
</style>
